import {baseRequestService} from "../base.ts";
import {Airport} from "../../types/domain.ts";

export const airportsGet = (includeIntl: boolean = false) => baseRequestService<Airport[]>({
    url: '/airports',
    method: 'GET',
    params: { includeIntl }
})